import { render, staticRenderFns } from "./ComGoodsRisk.vue?vue&type=template&id=33da037f&scoped=true&"
import script from "./ComGoodsRisk.vue?vue&type=script&lang=js&"
export * from "./ComGoodsRisk.vue?vue&type=script&lang=js&"
import style0 from "./ComGoodsRisk.vue?vue&type=style&index=0&id=33da037f&prod&lang=css&"
import style1 from "./ComGoodsRisk.vue?vue&type=style&index=1&id=33da037f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33da037f",
  null
  
)

export default component.exports